import React from 'react';
import { useSavedItems } from '../../../hooks/saved/useSavedItems';
import { SavedCourseCard } from './SavedCourseCard';

export function SavedCoursesList() {
  const { savedCourses, removeSavedCourse } = useSavedItems();

  if (savedCourses.length === 0) {
    return (
      <div className="p-8 text-center">
        <p className="text-gray-400">No saved courses yet. Start saving courses you want to learn!</p>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-4">
      {savedCourses.map(course => (
        <SavedCourseCard
          key={course.id}
          course={course}
          onRemove={() => removeSavedCourse(course.id)}
        />
      ))}
    </div>
  );
}